module.exports = __webpack_public_path__ + "img/small-processing.fd991343.gif";